import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { format, startOfMonth, endOfMonth, eachDayOfInterval } from 'date-fns';
import { hu } from 'date-fns/locale';

import { Button } from '@material-ui/core';

const getDaysInMonth = (date) => {
    const start = startOfMonth(date);
    const end = endOfMonth(date);
    const res = eachDayOfInterval({ start, end });
    // console.log(res);
    return res;
};

function WorkingHour(props) {
    const [workingHours, setWorkingHours] = useState([]);
    const [year, setYear] = useState(new Date().getFullYear());
    const [month, setMonth] = useState(new Date().getMonth());
    const [daysInMonth, setDaysInMonth] = useState(getDaysInMonth(new Date(year, month, 1)));
    const [editableCell, setEditableCell] = useState(null);
    const [modifiedInput, setModifiedInput] = useState(null);

    const callApi = useCallback(async () => {
        const response = await axios.get(`/api/attendances/${year}/${month + 1}`)
        console.log(response.data);
        return response.data;
    }, [year, month]);

    useEffect(function () {
        setDaysInMonth(getDaysInMonth(new Date(year, month, 1)));
        callApi()
            .then(res => setWorkingHours(res))
            .catch(err => console.log(err));
    }, [year, month, callApi]);

    const handleDelete = async (path, param) => {
        axios.delete(path, { data: param })
            .then((res) => { handleSuccess(res) })
            .catch(error => {
                console.log(error);
                return null;
            })
    }

    const handlePatch = async (path, param) => {
        axios.patch(path, param)
            .then((res) => { handleSuccess(res) })
            .catch(error => {
                console.log(error);
                return null;
            })
    }

    const handlePost = async (path, param) => {
        axios.post(path, param)
            .then((res) => { handleSuccess(res) })
            .catch(error => {
                console.log(error);
                return null;
            })
    }

    const handleSuccess = (response) => {
        callApi()
            .then(res => setWorkingHours(res))
            .catch(err => console.log(err));
    }

    const handleCellClick = (attendance, day, field) => {
        if (!day.secondaryDayType || day.secondaryDayType === 'MODIFIED_HOURS') {
            console.log("click");
            const employeeName = attendance.employeeName;
            const employeeId = attendance.employeeId;
            const employeeType = attendance.type;
            setEditableCell({ employeeName, employeeId, employeeType, day, field });
            setModifiedInput(day[field]);
        }
    };

    const handleInputChange = (event) => {
        const { value } = event.target;

        setModifiedInput(value);
    };

    const handleInputBlur = () => {
        handleChange();
    };

    const handleInputKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleChange();
        }
    };

    const handleChange = () => {
        setEditableCell(null);
        setModifiedInput(null);
        const date = new Date(year, month, editableCell.day.day);
        const startTime = editableCell.field === 'start' ? modifiedInput : (editableCell.day.start ? editableCell.day.start : '08:00');
        const endTime = editableCell.field === 'end' ? modifiedInput : (editableCell.day.end ? editableCell.day.end : '16:00');
        if (editableCell.employeeType === 'REGULAR') {
            handleChangeForRegular(date, startTime, endTime);
        } else {
            handleChangeForOccasional(date, editableCell, startTime, endTime)
        }
    }

    const handleChangeForOccasional = (date, editableCell, startTime, endTime) => {
        console.log("occasional");
        console.log(editableCell);
        if (startTime && endTime) {
            if (editableCell.day.occasionalSalary) {
                //modify
                console.log("modify");
                const request = {
                    privateId: editableCell.day.occasionalSalary.privateId,
                    publicId: editableCell.day.occasionalSalary.publicId,
                    name: editableCell.day.occasionalSalary.name,
                    date: editableCell.day.occasionalSalary.date,
                    startTime: startTime,
                    endTime: endTime
                };
                console.log(request);
                handlePatch('/api/occasionalsalary', request)

            } else {
                //new
                console.log("new");
                const request = {
                    name: editableCell.employeeName,
                    date: format(date, 'yyyy-MM-dd', { locale: hu }),
                    startTime: startTime,
                    endTime: endTime
                };
                console.log(request);
                handlePost('/api/occasionalsalary', request)
            }

        } else {
            //delete
            if (editableCell.day.occasionalSalary) {
                console.log('delete');
                const request = {
                    privateId: editableCell.day.occasionalSalary.privateId,
                };
                console.log(request);
                handleDelete('/api/occasionalsalary', request)
            }
        }
    }

    const handleChangeForRegular = (date, startTime, endTime) => {
        if (startTime && endTime) { //startTime or endTime is set (not deletion)
            console.log(editableCell);
            if (editableCell.day.workdayModification) { //there is modification already for this day
                if (startTime === '08:00' && endTime === '16:00' && editableCell.day.type === 'WEEKDAY') { //set time is 8-16 which is default, so this is a deletion for the modification
                    console.log('delete');
                    // delete
                    const request = {
                        privateId: editableCell.day.workdayModification.privateId
                    };
                    console.log(request);
                    handleDelete('/api/workdaymodification', request)
                } else { //not modification deletion, so modify modification
                    //modify
                    const request = {
                        privateId: editableCell.day.workdayModification.privateId,
                        employeeId: editableCell.employeeId,
                        date: format(date, 'yyyy-MM-dd', { locale: hu }),
                        startTime: startTime,
                        endTime: endTime
                    };
                    console.log(request);
                    handlePatch('/api/workdaymodification', request)
                }
            } else if (startTime === '08:00' && endTime === '16:00' && editableCell.day.type === 'WEEKDAY') { //set time is 8-16 on a weekday, there is no modification, user just clicked in a cell and left it as it was
                console.log("do nothing");
            } else { //new modification 
                //new
                const request = {
                    employeeId: editableCell.employeeId,
                    date: format(date, 'yyyy-MM-dd', { locale: hu }),
                    startTime: startTime,
                    endTime: endTime
                };
                console.log(request);
                handlePost('/api/workdaymodification', request)
            }
        } else if (editableCell.day.workdayModification && editableCell.day.type !== 'WEEKDAY') { //start or end time is empty on not a weekday when there is a modification, that means user want to delete the modification
            // delete
            console.log('delete');
            const request = {
                privateId: editableCell.day.workdayModification.privateId
            };
            console.log(request);
            handleDelete('/api/workdaymodification', request)
        }
    }

    const getHeaderCellClass = (day, index) => {
        if (workingHours[0] && workingHours[0].attendanceDays[index]) {
            return `${workingHours[0].attendanceDays[index].type}`;
        } else {
            return '';
        }
    }

    const getCellClass = (day, attendance) => {
        const editable = day.start || 'WEEKEND' === day.type || 'HOLIDAY' === day.type || attendance.type === 'OCCASIONAL' ? 'editable' : '';
        const modified = day.secondaryDayType && 'MODIFIED_HOURS' === day.secondaryDayType ? 'modified' : '';
        const vac = day.secondaryDayType && 'MODIFIED_HOURS' !== day.secondaryDayType ? 'vac' : '';
        const attendanceType = 'WEEKEND' !== day.type && 'HOLIDAY' !== day.type && attendance.type === 'OCCASIONAL' ? 'OCCASIONAL' : '';
        return `${day.type} ${attendanceType} ${editable} ${modified} ${vac}`;
    }

    const now = new Date(); // Get current date
    const currentYear = now.getFullYear(); // Get current year
    const currentMonth = now.getMonth(); // Get current month (January is 0)

    const handleNextMonth = () => {
        if (currentYear === year && month === currentMonth) {
            return;
        }
        if (month < 11) {
            setMonth(month + 1);
        } else if (month === 11) {
            setMonth(0);
            setYear(year + 1);
        }
    }
    const handlePreviousMonth = () => {
        if (month > 0) {
            setMonth(month - 1);
        } else if (month === 0) {
            setMonth(11);
            setYear(year - 1);
        }
    }
    const handleNow = () => {
        setMonth(currentMonth);
        setYear(currentYear);
    }

    const handleAttendancePdf = () => {
        const path = '/api/attendanceRegister';
        const requestObject = {
            year: year,
            month: month + 1
        };
        handlePdf(path, requestObject);
    }

    const handlePdf = (path, param) => {
        axios({
            url: path, //your url
            method: 'POST',
            responseType: 'arraybuffer', // important
            data: param,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/pdf'
            }
        })
            .then(handlePdfResult)
    }

    const handlePdfResult = (response) => {
        const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
    }

    return (
        <>
            {/* <LinkTab tabs={tabs} index={1} /> */}
            <div className="workday-container">
                <div className="buttons-left">
                    <Button variant="contained" onClick={handleNow}>Ma</Button>
                    <Button variant="contained" onClick={handlePreviousMonth}>Előző</Button>
                    <Button variant="contained" onClick={handleNextMonth}>Következő</Button>
                </div>
                <div className="title">
                    {`${year}. ${format(new Date(year, month), 'MMMM', { locale: hu })}`}
                </div>
                <div className="button-right">
                    <Button variant="contained" color="primary" component="span" onClick={handleAttendancePdf}>Jelenléti ív</Button>
                </div >
            </div>
            <table className="workinghour" border="1">
                <thead>
                    <tr key="header1">
                        <th rowSpan="2">Munkavállaló</th>
                        {daysInMonth.map((day, index) => (
                            <th className={getHeaderCellClass(day, index)} key={"day-" + index}>{format(day, 'd', { locale: hu })}</th>
                        ))}
                    </tr>
                    <tr key="header2">
                        {daysInMonth.map((day, index) => (
                            <th className={getHeaderCellClass(day, index)} key={`workday-${index}`}>{format(day, 'EEE', { locale: hu })}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {workingHours.map((attendance, index) => (
                        <React.Fragment key={`${index}-wh`}>
                            <tr key={`${index}-start-tr`}>
                                <td className={attendance.type} key={attendance.employeeName} rowSpan="2" >{attendance.employeeName}</td>
                                {attendance.attendanceDays.map((day, dayIndex) => (
                                    <React.Fragment key={`${dayIndex}-wh`}>
                                        {editableCell && editableCell.employeeName === attendance.employeeName && editableCell.day === day && editableCell.field === 'start' ? (
                                            <td key={`${index}-${dayIndex}-start-td`} className={getCellClass(day, attendance)}>
                                                <input
                                                    fullwidth="true"
                                                    type="time"
                                                    name="start"
                                                    value={modifiedInput}
                                                    onChange={handleInputChange}
                                                    onKeyDown={handleInputKeyDown}
                                                    onBlur={handleInputBlur}
                                                    autoFocus
                                                /></td>
                                        ) : (
                                            <td key={`${index}-${dayIndex}-start-td2`} className={getCellClass(day, attendance)} onClick={() => handleCellClick(attendance, day, 'start')}>
                                                {day.start ? day.start : day.hours}
                                            </td>
                                        )}
                                    </React.Fragment>
                                ))
                                }
                            </tr >
                            <tr key={`${index}-end-tr`}>
                                {attendance.attendanceDays.map((day, dayIndex) => (
                                    <React.Fragment key={`${dayIndex}-wh2`}>
                                        {editableCell && editableCell.employeeName === attendance.employeeName && editableCell.day === day && editableCell.field === 'end' ? (
                                            <td key={`${index}-${dayIndex}-end-td`} className={getCellClass(day, attendance)}>
                                                <input
                                                    fullwidth="true"
                                                    type="time"
                                                    name="end"
                                                    value={modifiedInput}
                                                    onChange={handleInputChange}
                                                    onKeyDown={handleInputKeyDown}
                                                    onBlur={handleInputBlur}
                                                    autoFocus
                                                /></td>
                                        ) : (
                                            <td key={`${index}-${dayIndex}-end-td2`} className={getCellClass(day, attendance)} onClick={() => handleCellClick(attendance, day, 'end')}>
                                                {day.end ? day.end : day.hours}
                                            </td>
                                        )}
                                    </React.Fragment>
                                ))
                                }
                            </tr>
                        </React.Fragment>
                    ))}
                </tbody>

            </table >
        </>
    );
};

export default WorkingHour;